// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3fo3V","label":"LabeledBox_label__w3Ups"};